<template>
  <div class="container">
    <Header :shrink="shrink" @switch="shrink = $event" />
    <main-layout>
      <router-view></router-view>
      <Footer />
    </main-layout>
    <SwitchModal :show="shrink" @click="shrink = $event" />
    <Aside :show="shrink" @switch="shrink = false" />
  </div>
</template>

<script>
import "@/assets/www.less";
import Header from "./components/Header";
import SwitchModal from "./components/SwitchModal";
import Aside from "./components/Aside";
import MainLayout from "./components/MainLayout";
import Footer from "./components/Footer";
export default {
  components: {
    Header,
    SwitchModal,
    Aside,
    MainLayout,
    Footer
  },
  data() {
    return {
      shrink: false
    };
  }
};
</script>
